const ITEM_INVENTORY = require('json!./ITEM_INVENTORY.json');
const VEHICLE_INVENTORY = require('json!./VEHICLE_INVENTORY.json');

export default ITEM_INVENTORY.concat(VEHICLE_INVENTORY);


// WEBPACK FOOTER //
// ./client/app/common/inventory/inventory.store.js